<template>
    <div class="series">
        <div class="series__title">- DCI产品系列 -</div>
        <div class="series__content">
            <div class="series__content__item" v-for="(item,index) in seriesList" :key='index' @mouseenter="enter(index)" @mouseleave="leave(index)">
                <div class="series__content__item__body">
                    <div class="series__content__item__body__mask"></div>
                    <div :class="choseItem === index ? 'series__content__item__body__show_chose' : 'series__content__item__body__show_leave'" class="series__content__item__body__show" :ref='`item${index}`' @click="more(item.id)">
                        <div>
                            <img src='https://static.zc0901.com/dci-web-series-item-icon.png' />
                            <span>{{item.title}}</span>
                        </div>
                        <div>{{item.content}}</div>
                        <img src='https://static.zc0901.com/dci-web-series-item-more.png' />
                    </div>
                    <img class="series__content__item__body_img" :src='item.image'/>
                </div>
                <img class="series__content__item__bottom" src='https://static.zc0901.com/dci-web-series-item-bottom.png' />
            </div>
        </div>
    </div>
</template>
<script>
import {mapActions,mapState} from 'vuex'
import "./index.scss";

	export default {
		data() {
			return {
                choseItem:-1,
                mask:false
			}
		},
		computed: {
			...mapState('series',['seriesList'])
		},
        async created(){
            await this.SERIESLIST()
            console.log('-------',this.seriesList)
        },
		mounted() {

		},
		methods: {
            ...mapActions('series',['SERIESLIST']),
            enter(index){
                this.choseItem = index
                this.$refs[`item${index}`][0].style.left = 0
            },
            leave(index){
                this.choseItem = -1
            },
            more(id){
                this.$router.push({
                    path: `../seriesDetail`,
                    query: {
                        id: id
                    }
				})
            },

        }
	}
</script>
